const data = [
  {
    name: 'Mercúrio',
    image: 'https://64.media.tumblr.com/b33c7d52e3d8a69c3c7bacf22565aa48/tumblr_mid0z4TjGC1s3yr8vo1_400.gifv',
  },
  {
    name: 'Vênus',
    image: 'https://zamforums.neocities.org/venus.gif',
  },
  {
    name: 'Terra',
    image: 'https://i.gifer.com/embedded/download/W31X.gif',
  },
  {
    name: 'Marte',
    image: 'https://c.tenor.com/SqJHatCJ40cAAAAj/mars.gif',
  },
  {
    name: 'Júpiter',
    image: 'https://freight.cargo.site/t/original/i/f1e7b125ee5d80491878e608bf50faa009bca85fb6f3276e1f0651ab448060f3/186539daa969fe74a48c2f78c681b02d.gif',
  },
  {
    name: 'Saturno',
    image: 'http://www.homestead.com/~media/elements/AnimatedClipart/Space/animations/saturn__spinningA.gif',
  },
  {
    name: 'Urano',
    image: 'https://www.centraldatacore.com/wp-content/uploads/PG3-Uranus-500-P-Anim.gif',
  },
  {
    name: 'Netuno',
    image: 'https://www.centraldatacore.com/wp-content/uploads/PG4-Neptune-500-P-Anim.gif',
  },
];

export default data;
